/**
 * Operational exceptions page (OS Buddy — issue #1097, epic #1085).
 *
 * Dedicated `/exceptions` route behind `scheduling.exceptions`. Hosts the foreman
 * queue of open operational exceptions; the queue itself owns data, realtime and
 * filtering (see ExceptionsQueue).
 */
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ExceptionsQueue } from './ExceptionsQueue';

export default function ExceptionsPage() {
  const { t } = useTranslation('exceptions');

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={600}>
          {t('title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {t('subtitle')}
        </Typography>
      </Box>
      <ExceptionsQueue />
    </Box>
  );
}
